module.exports = __webpack_public_path__ + "img/banner.5993c170.png";